import { render, staticRenderFns } from "./TicketRefsSelect.vue?vue&type=template&id=64fea44e&"
import script from "./TicketRefsSelect.vue?vue&type=script&lang=ts&"
export * from "./TicketRefsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports